/**
 * Example section component.  Don't edit this file directly!
 *
 * This section is specific to this project and not included in the core section components.
 * We can create templates here for any we don't want included in the core component set.
 *
 * New components can be bootstrapped from this manually,
 * or via the createsection cli script with the local option.
 */
import { useVariantImport } from '@edelman/storyblok-ui/src/hooks';
import { SBProps } from '@edelman/utils';

import * as Variant from './variants';

// Variants
const componentVariants = {
  default: Variant.DefaultVariant,
};

// Component classname identifier
const componentClassName = 'my-component';

export const SBProjectExampleSection = ({ blok, componentIndex }: SBProps) => {
  const { layoutVariant = 'default' } = blok;

  // Load variant
  const VariantComponent = useVariantImport({
    componentVariants,
    layoutVariant,
    importLocal: false,
  });

  return (
    <VariantComponent
      blok={blok}
      componentClassName={componentClassName}
      componentIndex={componentIndex}
    />
  );
};
